import { useEffect, useState } from 'react';

/**
 * Estado de la conexión (S-08).
 *
 * `navigator.onLine` no es una verdad: dice si hay una interfaz de red, no si el
 * servidor contesta. Alcanza igual para lo que la pantalla necesita —decidir si
 * mostrar el banner y si conviene intentar el envío— y lo que resuelve de verdad
 * el caso es la cola: si el envío falla estando "online", igual queda encolado.
 *
 * Nunca bloquea. El paciente sigue respondiendo su check-in sin conexión; lo que
 * cambia es cuándo llega el dato, no si se puede responder.
 */
export function useEstadoDeConexion(): boolean {
  const [enLinea, setEnLinea] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const conectado = () => setEnLinea(true);
    const desconectado = () => setEnLinea(false);

    window.addEventListener('online', conectado);
    window.addEventListener('offline', desconectado);
    return () => {
      window.removeEventListener('online', conectado);
      window.removeEventListener('offline', desconectado);
    };
  }, []);

  return enLinea;
}
